<template>
  <div class="section mt-3 mb-5">
    <div>Go to the beginning of the method:</div>
    <pc-hotkey>Left Click</pc-hotkey>
    <div class="mt-2">Go to the end of the method:</div>
    <pc-hotkey shift>Left Click</pc-hotkey>
    <div class="mt-2">Scope to method:</div>
    <pc-hotkey command>Left Click</pc-hotkey>
    <div class="mt-1 text-secondary">(press
      <pc-hotkey command>Left Click</pc-hotkey>
      again on upper frame to exit or change method scope)
    </div>
  </div>
</template>
<script>
  import PcHotkey from './hotkey.component'

  export default {
    name: 'pc-graph-hotkeys',
    components: { PcHotkey },
  }
</script>
